module.exports = __webpack_public_path__ + "static/media/header_bg_1.97bcca9c.jpg";